/**
 * Utility functions for admin access control
 */

import { useTransactionCertificateStore } from '../../store/transaction-certificates.store';

/**
 * Check if user is an admin based on the isAdmin flag from store
 * This flag is set by calling the check-admin API after login
 * @returns boolean - true if user is admin
 */
export const isAdmin = (): boolean => {
  const { isAdmin } = useTransactionCertificateStore.getState();
  return isAdmin;
};

/**
 * Get the admin status from store
 * @returns boolean - true if CB-ID is in admin list
 */
export const getAdminStatus = (): boolean => {
  return useTransactionCertificateStore.getState().isAdmin;
};
